// source: https://stackoverflow.com/a/24103596/2786063
export default class Cookie {
  static setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    console.info(`Setting cookie ${name}`);
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  static getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  static eraseCookie(name) {
    console.log(`Erasing Cookie ${name}`);
    document.cookie = name+'=; Max-Age=-99999999;';
  }
}
